/*
 * Maja & Helena - size-guard.js
 * Geen schoenmaat automatisch geselecteerd; toevoegen zonder maatkeuze wordt geblokkeerd.
 *
 * Werkt alleen waar de optie "Rozmiar" uitsluitend schoenmaten bevat (35, 35,5, 36 ... 44,5).
 * Kleding (S/M/L/XL), kleur-swatches, sieraden en tassen worden niet aangeraakt.
 *
 * 1. Productpagina:
 *    - de standaard voorgeselecteerde maat wordt visueel gewist;
 *    - "Wybierz rozmiar" verschijnt onder de maatknoppen;
 *    - Add to Cart wordt geblokkeerd totdat de klant bewust een maat kiest.
 *
 * 2. Cart-drawer upsell (Kaching Cart-app):
 *    - de maat-dropdown start leeg;
 *    - "Dodaj teraz" werkt pas na een bewuste maatkeuze.
 *
 * Installatie:
 * 1. Sla dit bestand op als assets/size-guard.js
 * 2. Voeg vlak voor </body> in layout/theme.liquid toe:
 *
 * <script src="{{ 'size-guard.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var NUM = /^\d{2}(?:[.,]5)?$/;
  var HINT = 'Wybierz rozmiar';
  var ERROR = 'Wybierz rozmiar, aby dodać produkt do koszyka.';
  var ROOT = document.documentElement;
  var ITEM = '.kaching-product-upsell-item';

  var css = [
    'html.size-unconfirmed variant-selects input[name="Rozmiar"]:checked + label{background:transparent!important;color:inherit!important;box-shadow:none!important;}',
    '.size-guard-msg{margin:.8rem 0 0;font-size:1.3rem;line-height:1.4;color:rgba(0,0,0,.65);}',
    '.size-guard-msg.is-error{color:#c0392b;font-weight:600;}',
    '.size-guard-msg[hidden]{display:none;}',
    'html.size-guard-shake variant-selects .product-form__input--pills{animation:sizeGuardShake .35s;}',
    '@keyframes sizeGuardShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}',
    '.size-guard-upsell-msg{margin:.4rem 0 0;font-size:1.2rem;line-height:1.3;color:#c0392b;font-weight:600;}',
    '.size-guard-upsell-msg[hidden]{display:none;}',
    'select.size-guard-invalid{outline:2px solid #c0392b;outline-offset:1px;}'
  ].join('\n');

  var style = document.createElement('style');
  style.setAttribute('data-size-guard', '');
  style.textContent = css;
  document.head.appendChild(style);

  function allShoeSizes(values) {
    if (!values.length) return false;

    for (var i = 0; i < values.length; i++) {
      if (!NUM.test(String(values[i]).trim())) {
        return false;
      }
    }

    return true;
  }

  /* ---------------------------------------------------------------
     Productpagina
  ---------------------------------------------------------------- */

  var msgEl = null;

  function unconfirmed() {
    return ROOT.classList.contains('size-unconfirmed');
  }

  function showError() {
    if (msgEl) {
      msgEl.textContent = ERROR;
      msgEl.classList.add('is-error');
      msgEl.hidden = false;

      try {
        msgEl.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      } catch (e) {
        /* oudere browser */
      }
    }

    ROOT.classList.remove('size-guard-shake');

    void ROOT.offsetWidth;

    ROOT.classList.add('size-guard-shake');

    setTimeout(function () {
      ROOT.classList.remove('size-guard-shake');
    }, 400);
  }

  function confirmSize() {
    if (!unconfirmed()) return;

    ROOT.classList.remove('size-unconfirmed');

    if (msgEl) {
      msgEl.hidden = true;
    }
  }

  function initProductPage() {
    var vs = document.querySelector('variant-selects');

    if (!vs || vs.getAttribute('data-size-guard')) {
      return;
    }

    var radios = [].slice.call(
      vs.querySelectorAll('input[type="radio"][name="Rozmiar"]')
    );

    if (
      !radios.length ||
      !allShoeSizes(
        radios.map(function (r) {
          return r.value;
        })
      )
    ) {
      return;
    }

    vs.setAttribute('data-size-guard', '1');

    var group =
      radios[0].closest('.product-form__input') || vs;

    msgEl = document.createElement('p');
    msgEl.className = 'size-guard-msg';
    msgEl.setAttribute('role', 'status');
    msgEl.textContent = HINT;

    group.appendChild(msgEl);

    ROOT.classList.add('size-unconfirmed');

    /*
     * Een bewuste klik op een maat bevestigt de keuze.
     * Ook wanneer die maat technisch al vooraf door Shopify geselecteerd was.
     */
    group.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest
          ? e.target.closest(
              'label[for], input[name="Rozmiar"]'
            )
          : null;

        if (!el) return;

        var input =
          el.tagName === 'INPUT'
            ? el
            : document.getElementById(
                el.getAttribute('for')
              );

        if (
          input &&
          input.name === 'Rozmiar'
        ) {
          confirmSize();
        }
      },
      true
    );

    group.addEventListener(
      'keydown',
      function (e) {
        if (
          (e.key === 'Enter' || e.key === ' ') &&
          e.target &&
          e.target.name === 'Rozmiar'
        ) {
          confirmSize();
        }
      },
      true
    );
  }

  /*
   * Blokkeer toevoegen vanaf hoofdknop
   * en sticky Add to Cart zolang geen maat
   * bewust gekozen is.
   */
  document.addEventListener(
    'click',
    function (e) {
      if (!unconfirmed()) return;

      var btn = e.target.closest
        ? e.target.closest(
            '.main-product-atc, ' +
            '.main-product-form button[name="add"], ' +
            '.main-product-form .atc-button'
          )
        : null;

      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      showError();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (!unconfirmed()) return;

      var form = e.target;

      if (
        form &&
        form.closest &&
        form.closest('.main-product-form')
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();

        showError();
      }
    },
    true
  );

  /* ---------------------------------------------------------------
     Cart drawer upsell - Kaching Cart
  ---------------------------------------------------------------- */

  var confirmedProducts = {};

  function itemSizeSelect(item) {
    var select = item.querySelector(
      'select[name="Rozmiar"]'
    );

    if (!select) return null;

    var values = [].slice
      .call(select.options)
      .map(function (option) {
        return option.value;
      })
      .filter(function (value) {
        return value !== '';
      });

    return allShoeSizes(values)
      ? select
      : null;
  }

  function initUpsells() {
    [].forEach.call(
      document.querySelectorAll(ITEM),
      function (item) {
        var select = itemSizeSelect(item);

        if (!select) return;

        var productId =
          item.getAttribute('data-product-id');

        if (confirmedProducts[productId]) {
          return;
        }

        /*
         * Geen automatisch geselecteerde maat
         * in de upsell.
         */
        if (select.selectedIndex !== -1) {
          select.selectedIndex = -1;
        }
      }
    );
  }

  document.addEventListener(
    'change',
    function (e) {
      var select = e.target;

      if (
        !select ||
        !select.matches ||
        !select.matches(
          ITEM + ' select[name="Rozmiar"]'
        )
      ) {
        return;
      }

      var item = select.closest(ITEM);

      if (
        select.value !== '' &&
        item
      ) {
        confirmedProducts[
          item.getAttribute('data-product-id')
        ] = true;
      }

      select.classList.remove(
        'size-guard-invalid'
      );

      var msg = item
        ? item.querySelector(
            '.size-guard-upsell-msg'
          )
        : null;

      if (msg) {
        msg.hidden = true;
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var addButton = e.target.closest
        ? e.target.closest(
            ITEM + '__add-to-cart'
          )
        : null;

      if (!addButton) return;

      var item =
        addButton.closest(ITEM);

      var select =
        item && itemSizeSelect(item);

      if (!select) return;

      var productId =
        item.getAttribute('data-product-id');

      if (
        confirmedProducts[productId]
      ) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      select.classList.add(
        'size-guard-invalid'
      );

      var msg =
        item.querySelector(
          '.size-guard-upsell-msg'
        );

      if (!msg) {
        msg =
          document.createElement('div');

        msg.className =
          'size-guard-upsell-msg';

        msg.setAttribute(
          'role',
          'alert'
        );

        var footer =
          item.querySelector(
            ITEM + '__footer'
          );

        if (footer) {
          footer.insertBefore(
            msg,
            footer.firstChild
          );
        } else {
          item.appendChild(msg);
        }
      }

      msg.textContent = ERROR;
      msg.hidden = false;
    },
    true
  );

  /* ---------------------------------------------------------------
     Start
  ---------------------------------------------------------------- */

  function run() {
    initProductPage();
    initUpsells();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      run
    );
  } else {
    run();
  }

  /*
   * De Kaching cart drawer wordt dynamisch
   * opnieuw opgebouwd. Daarom opnieuw initialiseren.
   */
  var timer = null;

  new MutationObserver(function () {
    clearTimeout(timer);

    timer = setTimeout(
      run,
      60
    );
  }).observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();